export const objectDataToArray = (object) =>
  (typeof object === 'object' && object !== null
    ? Object.keys(object).map((item) => object[item])
    : []);
